/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
// BASE Components
import BASESvgIcon from '../../../../@BASE/core/BASESvgIcon';
// Material UI
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import clsx from 'clsx';
// actions
import { getInstanceCommentsCounts } from '../../../actions';

function PageInfo({ section, className }) {
  const dispatch = useDispatch();
  const [totalCommentCount, setTotalCommentCount] = useState(0);
  const getCommentCount = async () => {
    try {
      const countResponse = await dispatch(
        getInstanceCommentsCounts('sections')({
          id: section.id,
          showInternal: 'external'
        })
      ).unwrap();
      setTotalCommentCount(
        countResponse.pending +
          countResponse.approved +
          countResponse.disapproved
      );
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (!section) {
      return;
    }

    getCommentCount();
  }, [section]);

  if (!section) {
    return null;
  }

  return (
    <div className={clsx('w-full', className)}>
      <div className="flex items-center justify-between mb-16">
        <Chip
          className="font-semibold text-12"
          color="secondary"
          label={section?.classification
            .split('_')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')}
          size="small"
        />
      </div>

      <Typography className="text-16 font-medium">{section?.title}</Typography>

      <Typography className="text-13 mt-2 line-clamp-2" color="text.secondary">
        {section?.label}
      </Typography>

      <Divider className="w-48 my-24 border-1" light />

      <Typography
        className="flex items-center space-x-6 text-md"
        color="text.secondary"
      >
        <BASESvgIcon color="disabled" size={20}>
          heroicons-outline:calendar
        </BASESvgIcon>
        <span className="whitespace-nowrap leading-none">Alpha</span>
      </Typography>
      <Typography
        className="flex items-center space-x-6 text-md mt-8"
        color="text.secondary"
      >
        <BASESvgIcon color="disabled" size={20}>
          heroicons-outline:chat-alt-2
        </BASESvgIcon>
        <span className="whitespace-nowrap leading-none">{`${totalCommentCount} Comments`}</span>
      </Typography>
    </div>
  );
}

export default PageInfo;
